import styled from 'styled-components';

export const EmptyArchiveMessageContainer = styled.div`
  margin: 20px;
  text-align: center;
`;
